import {
  deleteApiV1ThreeLetterCodeClientAdminsBranchesId,
  getGetApiV1ThreeLetterCodeClientAdminsBranchesKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import { useMutation } from '@fukuri-admins/hooks/common';
import { AxiosError } from 'axios';

/**
 * 事業所削除 API を実行するカスタムフック
 *
 * @param threeLetterCode - クライアントコード
 * @param options - コールバックオプション
 * @param options.onSuccess - 成功時のコールバック
 * @param options.onError - エラー時のコールバック
 */
export const useDeleteBranch = (
  threeLetterCode: string,
  options?: {
    onSuccess?: () => void;
    onError?: (error: AxiosError<{ errors?: string[] }>) => void;
  }
) => {
  return useMutation(
    getGetApiV1ThreeLetterCodeClientAdminsBranchesKey(threeLetterCode),
    (_, { arg }: { arg: number }) =>
      deleteApiV1ThreeLetterCodeClientAdminsBranchesId(threeLetterCode, arg),
    options
  );
};
